// @ts-nocheck
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import BookingAddOnCard from '../BookingAddOnCard/BookingAddOnCard';
import { planIsSoldOut, planIsPastDeadline } from '../../../../utils/booking';
import PropTypes from 'prop-types';
import './BookingAddOnsPanel.css';

/**
 * BookingAddOnsPanel component for selecting trip add-ons during booking
 *
 * @namespace Components
 *
 * @param {Object} props - Component props
 * @param {string} [props.id] - The ID for the add-ons panel element
 * @param {...any} props.rest - Additional props to be spread on the parent element
 *
 * @returns {JSX.Element} React element representing the booking add-ons panel
 */
const BookingAddOnsPanel = ({ id, ...rest }) => {
  const { t } = useTranslation(['trip', 'common']);
  const addons = useSelector((state) => state.booking.addons || []);
  const passengerForms = useSelector(
    (state) => state.booking.passengerForms || []
  );
  // Check if user is logged in (staff) by checking localStorage directly
  // This is more reliable than Redux state since BookingModal may be used on public pages
  const getUserSession = () => {
    try {
      const userSession = localStorage.getItem('userSession');
      return userSession ? JSON.parse(userSession) : null;
    } catch (e) {
      return null;
    }
  };

  const userSession = getUserSession();
  const isStaff = Boolean(userSession?.userId);

  // Filter out hidden add-ons and handle auto-hide conditions
  // Staff users (logged in) see all add-ons regardless of visibility settings
  const visibleAddOns = addons.filter((addon) => {
    // Staff users bypass all visibility filters
    if (isStaff) return true;

    // Public users (not logged in) respect visibility settings
    if (addon?.ishiddenfrompassengers) return false;

    // Hide if sold out and autohidewhensoldout is enabled
    if (addon?.autohidewhensoldout && planIsSoldOut(addon)) return false;

    // Hide if past deadline and autohideafterdeadline is enabled
    if (addon?.autohideafterdeadline && planIsPastDeadline(addon)) return false;

    return true;
  });

  return (
    <Box
      id={id}
      className='book-now-modal__payment-options book-now-modal___left-panel'
      data-testid='booking-addons-panel'
      {...rest}
    >
      <div className='book-now-modal__plans-container'>
        {visibleAddOns.length === 0 ? (
          <Box className='booking-addons-panel__empty'>
            <p className='text-md-regular'>
              {t(
                'trip:noAddOnsAvailable',
                'No add-ons available for this trip.'
              )}
            </p>
          </Box>
        ) : (
          <>
            {visibleAddOns.map((addon) => (
              <BookingAddOnCard
                key={addon.tripaddonid}
                addon={addon}
                passengers={passengerForms}
              />
            ))}
          </>
        )}
      </div>
    </Box>
  );
};

BookingAddOnsPanel.propTypes = {
  id: PropTypes.string
};

export default BookingAddOnsPanel;
